import * as React from 'react'

import type { TentacleErrorData } from 'modules/core/lib/parseErrorData'

import Chart from 'modules/reports/components/Chart'
import type ReportStruct from 'modules/reports/lib/ReportStruct'

import styles from './index.module.scss'

interface Props {
  reportStruct: ReportStruct
  loading: boolean
  data: any
  error?: TentacleErrorData | Error
}

export function Content({ reportStruct, loading, data, error }: Props) {
  const applyLegend = (reportStruct: ReportStruct): boolean => {
    return reportStruct.isPie
  }

  return (
    <div className={styles.content}>
      <div className={styles.contentInner}>
        <Chart
          data={data}
          error={error}
          reportStruct={reportStruct}
          loading={loading}
          showLegend={applyLegend(reportStruct)}
          reduceMargins={false}
        />
      </div>
    </div>
  )
}
